export { default as InputOptionDisplay } from "./InputOptionToDisplay";
